const constants = require('@/util/constants')
require('./config')

/**
 * 获取会话小结
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getSummary (tid, successcb, failedcb) {
  axios.get('/api/summary/get', {
    params: {
      'tid': tid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 分页获取历史会话小结
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function querySummaries(page, size, successcb, failedcb) {
  axios.get('/api/summary/query', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建会话小结
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createSummary (tid, summary, successcb, failedcb) {
  axios.post('/api/summary/create', {
    'tid': tid,
    'solved': summary.solved,
    'content': summary.content,
    'tags': summary.tags,
    'client': constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新会话小结
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateSummary (summary, successcb, failedcb) {
  axios.post('/api/summary/update', {
    'sid': summary.sid,
    'solved': summary.solved,
    'content': summary.content,
    'tags': summary.tags,
    'client': constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除会话小结
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteSummary (id, successcb, failedcb) {
  axios.post('/api/summary/delete', {
    id,
    'client': constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
